// @flow

type NameValue = {| name: string, value: number |};

export default class MyRgsLoginDictionaries {
	identityDocumentTypes: Array<NameValue> = [];

	loadData = (data) => {
		this.identityDocumentTypes = data.documentTypes;
	}
}
